module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SliderVideo"
  }, [_c('div', {
    staticClass: "SliderVideo-controls"
  }, [_c('div', {
    staticClass: "SliderVideo-button",
    on: {
      "click": _vm.togglePlay
    }
  }, [(_vm.isPlaying) ? _c('icon', {
    staticClass: "SliderVideo-pause",
    attrs: {
      "name": "pause",
      "width": "42px",
      "height": "45px"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('icon', {
    staticClass: "SliderVideo-play",
    attrs: {
      "name": "play",
      "width": "17.42px",
      "height": "19.85px"
    }
  }) : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "SliderVideo-progress",
    attrs: {
      "width": "80px",
      "height": "80px"
    }
  }, [_c('circle', {
    staticClass: "SliderVideo-progressCircle",
    attrs: {
      "r": "36",
      "cx": "40",
      "cy": "40",
      "stroke-dasharray": _vm.dasharray,
      "stroke-dashoffset": _vm.dashoffset
    }
  })])], 1)]), _vm._v(" "), _c('player', {
    ref: "player",
    staticClass: "SliderVideo-video",
    attrs: {
      "options": _vm.options
    },
    on: {
      "timeupdate": _vm.handleTimeupdate,
      "play": _vm.handlePlay,
      "pause": _vm.handlePause,
      "ended": _vm.handleEnded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5033e832"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/Video.vue
// module id = 419
// module chunks = 1